import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'
import { ActivityItem } from '../../siteDetailTypes'

const Container = styled.div`
  padding: 1.5rem 0;
`

const Title = styled(Text)`
  font-weight: 600;
  margin-bottom: 1rem;
`

const ActivityList = styled.div`
  display: flex;
  flex-direction: column;
`

const ActivityRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background-color: ${palette.white};
  border: 1px solid ${palette.grey.grey200};
  border-bottom: none;

  &:first-child {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  &:last-child {
    border-bottom: 1px solid ${palette.grey.grey200};
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
`

const ActivityLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

const Avatar = styled.div`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background-color: ${palette.primary.pink100};
  color: ${palette.primary.pink800};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.75rem;
`

const ActivityText = styled(Text)`
  font-size: 0.9375rem;
`

const EmployeeName = styled.span`
  font-weight: 600;
`

const HighlightedText = styled.span`
  font-weight: 500;
`

const Timestamp = styled(Text)`
  color: ${palette.text.secondary};
  font-size: 0.8125rem;
`

const ViewAllButton = styled.button`
  width: 100%;
  background-color: ${palette.grey.grey50};
  color: ${palette.text.secondary};
  padding: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid ${palette.grey.grey200};
  border-top: none;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${palette.grey.grey100};
  }
`

interface ActivityTabProps {
  activities: ActivityItem[]
}

const ActivityTab = ({ activities }: ActivityTabProps) => {
  return (
    <Container>
      <Title variant='body1'>Recent Activity</Title>

      <ActivityList>
        {activities.map((activity, index) => (
          <ActivityRow key={activity.id}>
            <ActivityLeft>
              <Avatar>{activity.initials}</Avatar>
              <ActivityText>
                <EmployeeName>{activity.employeeName}</EmployeeName>{' '}
                {activity.action}
                {activity.highlightedText && (
                  <HighlightedText> {activity.highlightedText}</HighlightedText>
                )}
              </ActivityText>
            </ActivityLeft>
            <Timestamp>{activity.timestamp}</Timestamp>
          </ActivityRow>
        ))}
      </ActivityList>

      <ViewAllButton>View All Activity</ViewAllButton>
    </Container>
  )
}

export default React.memo(ActivityTab)
